export const GET_INBOX_START = 'GET_INBOX_START'
export const GET_INBOX_SUCCESS = 'GET_INBOX_SUCCESS'
export const GET_INBOX_FAIL = 'GET_INBOX_FAIL'

export const GET_CONVERSATION_START = 'GET_CONVERSATION_START'
export const GET_CONVERSATION_SUCCESS = 'GET_CONVERSATION_SUCCESS'

export const GET_STOPBOTEVENTS_START = 'GET_STOPBOTEVENTS_START'
export const GET_STOPBOTEVENTS_SUCCESS = 'GET_STOPBOTEVENTS_SUCCESS'

export const REGISTER_SOCKET_MESSAGE = 'REGISTER_SOCKET_MESSAGE'
export const OPERATOR_MESSAGE_SUBMIT = 'OPERATOR_MESSAGE_SUBMIT'

export const RECLASSIFY_START = 'RECLASSIFY_START'

export const RESET_HISTORICAL_DIALOGUE = 'RESET_HISTORICAL_DIALOGUE'

export const GET_STATUSES_START = 'GET_STATUSES_START'
export const GET_STATUSES_SUCCESS = 'GET_STATUSES_SUCCESS'
export const GET_STATUSES_FAIL = 'GET_STATUSES_FAIL'

export const GET_INTENT_ENTITY_MAP_START = 'GET_INTENT_ENTITY_MAP_START'
export const GET_INTENT_ENTITY_MAP_SUCCESS = 'GET_INTENT_ENTITY_MAP_SUCCESS'
export const GET_INTENT_ENTITY_MAP_FAIL = 'GET_INTENT_ENTITY_MAP_FAIL'

export const GET_DIALOGUE_GENERAL_INFO_START = 'GET_DIALOGUE_GENERAL_INFO_START'
export const GET_DIALOGUE_GENERAL_INFO_SUCCESS = 'GET_DIALOGUE_GENERAL_INFO_SUCCESS'
export const GET_DIALOGUE_GENERAL_INFO_FAIL = 'GET_DIALOGUE_GENERAL_INFO_FAIL'

export const GET_TAB_COUNT_SUCCESS = 'GET_TAB_COUNT_SUCCESS'

export const GET_ADF_START = 'GET_ADF_START'
export const GET_ADF_SUCCESS = 'GET_ADF_SUCCESS'
export const GET_ADF_FAIL = 'GET_ADF_FAIL'

export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS'
